import React from "react";

export const VehicleListingDetailContext = React.createContext(null);

export const useVehicleListingDetailContext = () => {
  const context = React.useContext(VehicleListingDetailContext);

  if (!context)
    throw new Error("External Driver Record Detail Context not provided!");

  return context;
};
